import dayjs from 'dayjs';

export const isDayInFuture = (day: { scheduledAt: string }) =>
  dayjs().startOf('day') < dayjs(day.scheduledAt).startOf('day');
